import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { Button, ListGroup } from 'react-bootstrap'
import FontAwesomeIcon from '@severed-links/common.font-awesome-icon'
import EditTicket from './EditTicket'
import TicketListItem from './TicketListItem'
import { orderBy } from 'lodash'
import { getMyTickets, getOthersTickets, getHelperRoles, toggleTicketModal, setActiveTicket } from '@severed-links/common.redherrings-reducers/help'
import Alert from '@severed-links/common.alert'
import * as s from './HelpCenter.scss'
import Modal from '@severed-links/common.modal'

const HelpCenter = ({ showAllTickets = false, }) => {

    const dispatch = useDispatch()
    const params = useParams()
    const { tickets, otherTickets, activeTicket, showActiveTicket, helperRoles } = useSelector(state => state.help)
    const { _id: playerId } = useSelector(state => state.account)
    const appName = showAllTickets ? 'RedHerrings' : (params.appName || '').toLowerCase()

    useEffect(() => { loadTickets() }, [])

    const loadTickets = () => {
        dispatch(getHelperRoles())
        dispatch(getMyTickets())
        dispatch(getOthersTickets())
    }

    const closeModal = () => {
        dispatch(toggleTicketModal(false))
        loadTickets()
    }

    const newTicketItem = {
        _id: null,
        app: appName,
        ticketType: '',
        description: '',
        createDate: null,
        updateDate: null,
        isCompletedTicket: false,
        isDeletedTicket: false,
        player: { _id: null },
        sortOrder: 1,
        comments: [],
        commentCount: 0,
        commentUnreadCount: 0
    }

    const newTicket = () => {
        dispatch(setActiveTicket({ ...newTicketItem, player: { _id: playerId } }))
        dispatch(toggleTicketModal(true))
    }

    const myTickets = orderBy(tickets || [], ['sortOrder','updateDate'], ['asc','desc'])
    const ticketsFromOthers = orderBy(otherTickets || [], ['sortOrder','updateDate'], ['asc','desc'])

    return (
        <div className={s.container}>
            <section className={s.hero}>
                <div className={s.heroIcon}><FontAwesomeIcon name='life-ring' /></div>
                <div className={s.heroText}>
                    <div className={s.eyebrow}>REDHERRINGS</div>
                    <h2>Help Center</h2>
                    <p>Submit problems with the site, feature requests, or feedback.</p>
                </div>
                <Button className={s.newTicketButton} variant='primary' onClick={() => newTicket()}>
                    <FontAwesomeIcon name='plus-circle' />
                    <span>add new issue</span>
                </Button>
            </section>

            <section className={s.ticketSection}>
                <div className={s.sectionHeader}>
                    <div>
                        <h3>Your open issues</h3>
                        <p>Tickets you created that still need attention.</p>
                    </div>
                    <span className={s.countBadge}>{myTickets.length}</span>
                </div>
                {myTickets.length === 0 ?
                    <Alert className={s.emptyState} small variant='info' icon='info-circle'
                        message='You have no open issues.' />
                :
                    <ListGroup className={s.ticketList}>
                    {myTickets.map(t => <TicketListItem key={t._id} t={t} />)}
                    </ListGroup>
                }
            </section>

            {helperRoles?.length ?
            <section className={s.ticketSection}>
                <div className={s.sectionHeader}>
                    <div>
                        <h3>Open issues from others</h3>
                        <p>Tickets visible because you can help with these contest areas.</p>
                    </div>
                    <span className={s.countBadge}>{ticketsFromOthers.length}</span>
                </div>
                {ticketsFromOthers.length ?
                    <ListGroup className={s.ticketList}>
                    {ticketsFromOthers.map(t => <TicketListItem key={t._id} t={t} />)}
                    </ListGroup>
                :
                    <Alert className={s.emptyState} small variant='info' icon='info-circle'
                        message='You have no open issues to help others with.' />
                }
            </section> : null}


            <Modal heading={(activeTicket && !activeTicket._id ? 'New ' : 'Edit ') + 'Help Ticket'}
                show={showActiveTicket}
                onClose={() => closeModal()}
                size='lg'
                showFooter={false}>
                <EditTicket />
            </Modal>

        </div>
    )
}

export default HelpCenter
